import * as ActionPartnerTypes from 'actions/partner';

const defaultState = {};

export default function accountPlayer(state = defaultState, action) {
  switch (action.type) {
    case ActionPartnerTypes.ACCOUNT_PLAYER_UPDATE_RECEIVE:
      return { ...state, player: { ...state.player, ...action.payload } };
    case ActionPartnerTypes.ACCOUNT_PLAYER_RESET_COHORTS_RECEIVE:
      return { ...state, player: { ...state.player, ...action.payload } };
    case ActionPartnerTypes.ACCOUNT_PLAYER_RECEIVE: {
      const player = { ...action.payload.player, plays: action.payload.plays, stats: action.payload.stats };
      return { ...action.payload, player };
    }
    case ActionPartnerTypes.ACCOUNT_PLAYER_DELETE_RECEIVE:
      if (action.meta.id !== state.player.id) return;
      return { ...state, player: { ...state.player, deleted: true } };
    case ActionPartnerTypes.ACCOUNT_PLAYER_ENGAGEMENT_RECEIVE:
    case ActionPartnerTypes.ACCOUNT_PLAYER_INTERACTIVITY_RECEIVE:
    case ActionPartnerTypes.ACCOUNT_PLAYER_PLAYS_RECEIVE:
      return { ...state, ...action.payload };
    case ActionPartnerTypes.ACCOUNT_PLAYER_FREE_PLAYS_RECEIVE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
